var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _controller, _activeFetch, _handleModalClick, _handleKeyboardShortcut, _handleDialogOpen, _handleDialogClose, _handleFocusIn, _handleFocusOut, _PredictiveSearchComponent_instances, closePredictiveSearch_fn, allResultsItems_get, _isKeyboardNavigation, currentIndex_get, currentIndex_set, currentItem_get, resetScrollPositions_fn, getSearchResults_fn, hideResetButton_fn, showResetButton_fn, createAbortController_fn, _resetSearch, _cachedPredictiveSearchEmpty;
import { C as Component, L as onDocumentLoaded, G as isKeyboardUser, d as debounce, s as sectionRenderer, J as morph, q as activateInteractionAssets, t as lazyReveal } from "./utilities-Da0sjanJ.js";
import { D as DialogOpenEvent, a as DialogCloseEvent } from "./custom-dialog-MTSjyveX.js";
class PredictiveSearchComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _PredictiveSearchComponent_instances);
    __publicField(this, "requiredRefs", ["searchInput", "predictiveSearchResults", "resetButton"]);
    __privateAdd(this, _controller, new AbortController());
    /**
     * @type {AbortController | null}
     */
    __privateAdd(this, _activeFetch, null);
    /**
     * Handles clicks within the predictive search modal to maintain focus on the input
     * @param {MouseEvent} event - The mouse event
     */
    __privateAdd(this, _handleModalClick, (event) => {
      const target = (
        /** @type {HTMLElement} */
        event.target
      );
      const isInteractiveElement = target instanceof HTMLButtonElement || target instanceof HTMLAnchorElement || target instanceof HTMLInputElement || target.closest("button") || target.closest("a") || target.closest("input");
      if (!isInteractiveElement && this.refs.searchInput && isKeyboardUser()) {
        this.refs.searchInput.focus();
      }
    });
    /**
     * Handles the CMD+K key combination.
     * @param {KeyboardEvent} event - The keyboard event.
     */
    __privateAdd(this, _handleKeyboardShortcut, (event) => {
      var _a;
      if (event.metaKey && event.key === "k") {
        (_a = this.dialog) == null ? void 0 : _a.toggleDialog();
      }
    });
    /**
     * Handles the dialog open event.
     */
    __privateAdd(this, _handleDialogOpen, () => {
      var _a;
      if (isKeyboardUser()) {
        (_a = this.refs.searchInput) == null ? void 0 : _a.focus();
      }
    });
    /**
     * Handles the dialog close event.
     */
    __privateAdd(this, _handleDialogClose, () => {
      __privateGet(this, _resetSearch).call(this);
    });
    /**
     * Handles focus entering the component (non-dialog mode).
     * Opens the predictive search dropdown immediately on focus.
     */
    __privateAdd(this, _handleFocusIn, () => {
      this.classList.add("has-value");
      const searchTerm = this.refs.searchInput.value.trim();
      if (searchTerm.length > 0) {
        __privateMethod(this, _PredictiveSearchComponent_instances, getSearchResults_fn).call(this, searchTerm);
      }
    });
    /**
     * Handles focus leaving the component.
     * Closes the predictive search dropdown if the new focused element is outside.
     * @param {FocusEvent} event
     */
    __privateAdd(this, _handleFocusOut, (event) => {
      const relatedTarget = (
        /** @type {HTMLElement} */
        event.relatedTarget
      );
      if (!this.contains(relatedTarget)) {
        __privateMethod(this, _PredictiveSearchComponent_instances, closePredictiveSearch_fn).call(this);
      }
    });
    /**
     * Track whether the last interaction was keyboard-based
     * @type {boolean}
     */
    __privateAdd(this, _isKeyboardNavigation, false);
    /**
     * Navigate through the predictive search results using arrow keys or close them with the Escape key.
     * @param {KeyboardEvent} event - The keyboard event.
     */
    __publicField(this, "onSearchKeyDown", (event) => {
      var _a, _b, _c;
      if (event.key === "Escape") {
        __privateMethod(this, _PredictiveSearchComponent_instances, closePredictiveSearch_fn).call(this);
        return;
      }
      if (!((_a = __privateGet(this, _PredictiveSearchComponent_instances, allResultsItems_get)) == null ? void 0 : _a.length) || event.key === "ArrowLeft" || event.key === "ArrowRight") {
        return;
      }
      const currentIndex = __privateGet(this, _PredictiveSearchComponent_instances, currentIndex_get);
      const totalItems = __privateGet(this, _PredictiveSearchComponent_instances, allResultsItems_get).length;
      switch (event.key) {
        case "ArrowDown":
          __privateSet(this, _isKeyboardNavigation, true);
          event.preventDefault();
          __privateSet(this, _PredictiveSearchComponent_instances, currentIndex < totalItems - 1 ? currentIndex + 1 : 0, currentIndex_set);
          break;
        case "Tab":
          if (event.shiftKey) {
            __privateSet(this, _isKeyboardNavigation, true);
            event.preventDefault();
            __privateSet(this, _PredictiveSearchComponent_instances, currentIndex > 0 ? currentIndex - 1 : totalItems - 1, currentIndex_set);
          } else {
            __privateSet(this, _isKeyboardNavigation, true);
            event.preventDefault();
            __privateSet(this, _PredictiveSearchComponent_instances, currentIndex < totalItems - 1 ? currentIndex + 1 : 0, currentIndex_set);
          }
          break;
        case "ArrowUp":
          __privateSet(this, _isKeyboardNavigation, true);
          event.preventDefault();
          __privateSet(this, _PredictiveSearchComponent_instances, currentIndex > 0 ? currentIndex - 1 : totalItems - 1, currentIndex_set);
          break;
        case "Enter": {
          const singleResultContainer = this.refs.predictiveSearchResults.querySelector("[data-single-result-url]");
          if (singleResultContainer instanceof HTMLElement && singleResultContainer.dataset.singleResultUrl) {
            event.preventDefault();
            window.location.href = singleResultContainer.dataset.singleResultUrl;
            return;
          }
          if (__privateGet(this, _PredictiveSearchComponent_instances, currentIndex_get) >= 0) {
            event.preventDefault();
            (_c = (_b = __privateGet(this, _PredictiveSearchComponent_instances, currentItem_get)) == null ? void 0 : _b.querySelector("a")) == null ? void 0 : _c.click();
          } else {
            const searchUrl = new URL(Theme.routes.search_url, location.origin);
            searchUrl.searchParams.set("q", this.refs.searchInput.value);
            window.location.href = searchUrl.toString();
          }
          break;
        }
      }
    });
    /**
     * Reset the search state.
     * @param {boolean} [keepFocus=true] - Whether to keep focus on input after reset
     */
    __publicField(this, "resetSearch", debounce((keepFocus = true) => {
      __privateGet(this, _resetSearch).call(this);
      if (keepFocus && isKeyboardUser()) {
        this.refs.searchInput.focus();
      } else {
        __privateMethod(this, _PredictiveSearchComponent_instances, closePredictiveSearch_fn).call(this);
      }
    }, 100));
    /**
     * Debounce the search handler to fetch and display search results based on the input value.
     * Reset the current selection index and close results if the search term is empty.
     */
    __publicField(this, "search", debounce((event) => {
      if (!event.inputType) return;
      const searchTerm = this.refs.searchInput.value.trim();
      __privateSet(this, _PredictiveSearchComponent_instances, -1, currentIndex_set);
      if (!searchTerm.length) {
        __privateGet(this, _resetSearch).call(this);
        return;
      }
      __privateMethod(this, _PredictiveSearchComponent_instances, showResetButton_fn).call(this);
      __privateMethod(this, _PredictiveSearchComponent_instances, getSearchResults_fn).call(this, searchTerm);
    }, 200));
    __privateAdd(this, _resetSearch, async () => {
      const { predictiveSearchResults, searchInput } = this.refs;
      __privateSet(this, _PredictiveSearchComponent_instances, -1, currentIndex_set);
      searchInput.value = "";
      __privateMethod(this, _PredictiveSearchComponent_instances, hideResetButton_fn).call(this);
      if (__privateGet(this, _activeFetch)) {
        __privateGet(this, _activeFetch).abort();
        __privateSet(this, _activeFetch, null);
      }
      if (__privateGet(this, _cachedPredictiveSearchEmpty) == null) throw new Error("No empty section markup found");
      predictiveSearchResults.replaceChildren(__privateGet(this, _cachedPredictiveSearchEmpty));
      __privateMethod(this, _PredictiveSearchComponent_instances, resetScrollPositions_fn).call(this);
    });
    __privateAdd(this, _cachedPredictiveSearchEmpty, null);
  }
  /**
   * Get the dialog component.
   * @returns {DialogComponent | null} The dialog component.
   */
  get dialog() {
    return this.closest("custom-dialog");
  }
  connectedCallback() {
    super.connectedCallback();
    const { dialog } = this;
    const { signal } = __privateGet(this, _controller);
    if (this.refs.searchInput.value.length > 0) {
      __privateMethod(this, _PredictiveSearchComponent_instances, showResetButton_fn).call(this);
    }
    if (dialog) {
      document.addEventListener("keydown", __privateGet(this, _handleKeyboardShortcut), { signal });
      dialog.addEventListener(DialogOpenEvent.eventName, __privateGet(this, _handleDialogOpen), { signal });
      dialog.addEventListener(DialogCloseEvent.eventName, __privateGet(this, _handleDialogClose), { signal });
      this.addEventListener("click", __privateGet(this, _handleModalClick), { signal });
    } else {
      this.addEventListener("focusin", __privateGet(this, _handleFocusIn), { signal });
      this.addEventListener("focusout", __privateGet(this, _handleFocusOut), { signal });
      const overlay = this.querySelector(".search-overlay");
      if (overlay) {
        overlay.addEventListener("mousedown", (e) => {
          e.preventDefault();
          __privateMethod(this, _PredictiveSearchComponent_instances, closePredictiveSearch_fn).call(this);
        }, { signal });
      }
    }
    onDocumentLoaded(() => {
      __privateSet(this, _cachedPredictiveSearchEmpty, this.querySelector(".predictive-search-empty"));
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    __privateGet(this, _controller).abort();
  }
}
_controller = new WeakMap();
_activeFetch = new WeakMap();
_handleModalClick = new WeakMap();
_handleKeyboardShortcut = new WeakMap();
_handleDialogOpen = new WeakMap();
_handleDialogClose = new WeakMap();
_handleFocusIn = new WeakMap();
_handleFocusOut = new WeakMap();
_PredictiveSearchComponent_instances = new WeakSet();
/**
 * Closes the predictive search dropdown and removes focus state.
 */
closePredictiveSearch_fn = function() {
  var _a;
  this.classList.remove("has-value");
  (_a = this.refs.searchInput) == null ? void 0 : _a.blur();
};
allResultsItems_get = function() {
  const containers = Array.from(
    this.querySelectorAll(
      ".predictive-search-results__wrapper-queries, .predictive-search-results__wrapper-products, .predictive-search-results__list"
    )
  );
  const allItems = containers.flatMap((container) => {
    if (container.classList.contains("predictive-search-results__wrapper-products")) {
      return Array.from(container.querySelectorAll(".predictive-search-results__card"));
    }
    return Array.from(container.querySelectorAll('[ref="resultsItems[]"], .predictive-search-results__card'));
  }).filter((item) => item instanceof HTMLElement);
  return (
    /** @type {HTMLElement[]} */
    allItems
  );
};
_isKeyboardNavigation = new WeakMap();
currentIndex_get = function() {
  var _a;
  return ((_a = __privateGet(this, _PredictiveSearchComponent_instances, allResultsItems_get)) == null ? void 0 : _a.findIndex((item) => item.getAttribute("aria-selected") === "true")) ?? -1;
};
currentIndex_set = function(index) {
  var _a;
  if (!((_a = __privateGet(this, _PredictiveSearchComponent_instances, allResultsItems_get)) == null ? void 0 : _a.length)) return;
  __privateGet(this, _PredictiveSearchComponent_instances, allResultsItems_get).forEach((item) => {
    item.classList.remove("keyboard-focus");
  });
  for (const [itemIndex, item] of __privateGet(this, _PredictiveSearchComponent_instances, allResultsItems_get).entries()) {
    if (itemIndex === index) {
      item.setAttribute("aria-selected", "true");
      if (__privateGet(this, _isKeyboardNavigation)) {
        item.classList.add("keyboard-focus");
      }
    } else {
      item.removeAttribute("aria-selected");
    }
  }
  if (isKeyboardUser()) {
    this.refs.searchInput.focus();
  }
};
currentItem_get = function() {
  var _a;
  return (_a = __privateGet(this, _PredictiveSearchComponent_instances, allResultsItems_get)) == null ? void 0 : _a[__privateGet(this, _PredictiveSearchComponent_instances, currentIndex_get)];
};
/**
 * Resets scroll positions for search results containers
 */
resetScrollPositions_fn = function() {
  requestAnimationFrame(() => {
    const resultsInner = this.refs.predictiveSearchResults.querySelector(".predictive-search-results__inner");
    if (resultsInner instanceof HTMLElement) {
      resultsInner.scrollTop = 0;
    }
    const formContent = this.querySelector(".predictive-search-form__content");
    if (formContent instanceof HTMLElement) {
      formContent.scrollTop = 0;
    }
  });
};
getSearchResults_fn = async function(searchTerm) {
  if (!this.dataset.sectionId) return;
  const url = new URL(Theme.routes.predictive_search_url, location.origin);
  url.searchParams.set("q", searchTerm);
  url.searchParams.set("resources[limit_scope]", "each");
  const { predictiveSearchResults } = this.refs;
  const abortController = __privateMethod(this, _PredictiveSearchComponent_instances, createAbortController_fn).call(this);
  sectionRenderer.getSectionHTML(this.dataset.sectionId, false, url).then((resultsMarkup) => {
    if (!resultsMarkup) return;
    if (abortController.signal.aborted) return;
    morph(predictiveSearchResults, resultsMarkup);
    activateInteractionAssets(predictiveSearchResults);
    lazyReveal(predictiveSearchResults);
    __privateMethod(this, _PredictiveSearchComponent_instances, resetScrollPositions_fn).call(this);
  }).catch((error) => {
    if (abortController.signal.aborted) return;
    throw error;
  });
};
hideResetButton_fn = function() {
  const { resetButton } = this.refs;
  resetButton.classList.add("hidden");
};
showResetButton_fn = function() {
  const { resetButton } = this.refs;
  resetButton.classList.remove("hidden");
};
createAbortController_fn = function() {
  const abortController = new AbortController();
  if (__privateGet(this, _activeFetch)) {
    __privateGet(this, _activeFetch).abort();
  }
  __privateSet(this, _activeFetch, abortController);
  return abortController;
};
_resetSearch = new WeakMap();
_cachedPredictiveSearchEmpty = new WeakMap();
if (!customElements.get("predictive-search-component")) {
  customElements.define("predictive-search-component", PredictiveSearchComponent);
}
